import {Component, OnInit, Optional} from '@angular/core';
import {DuelSeriesViewComponent} from "../duel-series-view/duel-series-view.component";
import {DuelSeriesService} from "../../services/duel-series.service";
import {BracketItemService} from "../../services/bracket-item.service";
import {DuelViewsServiceService} from "../../services/duel-views-service.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {PlayerReplacerService} from "../../services/player-replacer.service";

@Component({
  selector: 'app-duel-mobile-results',
  templateUrl: './duel-mobile-results.component.html',
  styleUrls: ['./duel-mobile-results.component.scss']
})
export class DuelMobileResultsComponent extends DuelSeriesViewComponent implements OnInit {

  constructor(
    duelSeriesService: DuelSeriesService,
    bracketItemService: BracketItemService,
    duelViewsService: DuelViewsServiceService,
    @Optional() activeModal: NgbActiveModal,
    @Optional() playerReplacerService: PlayerReplacerService,
  ) {
    super(duelSeriesService, bracketItemService, duelViewsService, activeModal, playerReplacerService);
  }

}
